/** Квант короба в разделе «Раскладка паллет».
 *
 * Квант (штук в коробе) и предупреждение по строке из 1С считает бэкенд
 * (`order_check.box_quantum`, `replan.box_warning`). Здесь — только то, что
 * нужно ЧЕРНОВИКУ: подпись позиции, тот же текст предупреждения для строки,
 * которую человек уже поправил (серверный текст про неё устарел), и
 * автоподстановка коробов. Тексты совпадают с бэкендом дословно — сторожат
 * `plan-boxes.test.ts` и `test_order_plan_review.py` на одних и тех же случаях.
 *
 * ⚠️ Неизвестный квант — НЕ единица: «один в коробе» и есть ошибка инцидента
 * MS-701 (40 шт / 40 кор при кванте 15, 20.10.2026). */
import type { QtyInBoxIssue } from "@/api/order_check";

const EPS = 0.001;

function fmtQty(q: number): string {
  return Number.isInteger(q) ? String(q) : String(Number(q.toFixed(3)));
}

function fmtBoxes(q: number): string {
  const r = Math.round(q * 10) / 10;
  return Number.isInteger(r) ? String(r) : String(r).replace(".", ",");
}

/** Подпись кванта у позиции; пустая строка — показывать нечего. */
export function quantumLabel(qtyInBox: number | null, issue: QtyInBoxIssue): string {
  if (qtyInBox) return `по ${qtyInBox} шт/кор`;
  if (issue === "not_filled") return "квант не заполнен";
  if (issue === "conflict") return "квант расходится между МП";
  // no_catalog — одна подсказка на страницу, а не у каждой строки;
  // not_requested — этот экран квант всегда запрашивает.
  return "";
}

/** Зеркало `replan.box_warning`: короба не бьются со штуками по кванту. */
export function boxWarning(qty: number, boxes: number, qtyInBox: number | null): string {
  if (!qtyInBox) return "";
  const expected = qty / qtyInBox;
  const whole = Math.abs(expected - Math.round(expected)) <= EPS;
  if (whole && Math.abs(boxes - expected) <= EPS) return "";
  if (!whole)
    return (
      `${fmtQty(qty)} шт не кратно коробу ${qtyInBox}: это ` +
      `${fmtBoxes(expected)} кор, в раскладке ${fmtQty(boxes)} кор`
    );
  return (
    `${fmtQty(qty)} шт — это ${fmtQty(Math.round(expected))} кор по ${qtyInBox}, ` +
    `в раскладке ${fmtQty(boxes)} кор`
  );
}

/** Короба для автоподстановки — только при ТОЧНОМ делении; иначе `null`
 *  (неполный короб человек считает сам, догадка тут хуже пустоты). */
export function prefillBoxes(qty: number, qtyInBox: number | null): number | null {
  if (!qtyInBox || qty <= 0) return null;
  const n = qty / qtyInBox;
  return Math.abs(n - Math.round(n)) <= EPS ? Math.round(n) : null;
}
